angular
  .module('countriesApp')
  .service('JobModel', [
    '$filter',
    'JobMinimalModel',
    function ($filter, JobMinimal) {
      /**
       * Formats the published date into a user-friendly format
       *
       * @param {string} publishedAtDate - Published at date field
       *
       * @returns {string} - Humanized published at date following specific format, to be shown in
       *                     the view
       */
      const formatPublishedAtDate = publishedAtDate => {
        return $filter('date')(new Date(publishedAtDate), 'd MMM yyyy');
      };

      return class JobModel extends JobMinimal {
        constructor(data) {
          super(data);

          if(data.published_at) {
            this.publishedAt = data.published_at;
            this.formattedPublishedAtDate = formatPublishedAtDate(data.published_at);
          }

          this.is_member = data.job_type === 2;
        }
      };
    }
  ]);
